import * as $runtime from "../runtime.js";
import * as Restaumatic$dAddress from "../Restaumatic.Address/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dPrelude$dSpecular from "../Restaumatic.Prelude.Specular/index.js";
import * as Restaumatic$dSite$dTranslations$dKeys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
const deliveryStatusWidget = config => dmethod => dresult => {
  const deliveryInProgress = Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("js-delivery-in-progress")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("i")([
    Specular$dDom$dElement.class_("icon-spinner icon-spin")
  ])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
    Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.delivery.checking_delivery),
    {}
  ))));
  return Specular$dFRP$dReplaceable.dynamic_(Specular$dDom$dBuilder.monadReplaceBuilder)({
    MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
    MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
  })(Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(method => result => {
    if (result.tag === "NotRequested") { return Specular$dInternal$dRIO.pureImpl(); }
    if (result.tag === "Loading") {
      if (config.showLoading) { return deliveryInProgress; }
      return Specular$dInternal$dRIO.pureImpl();
    }
    if (result.tag === "Loaded") {
      if (result._1.tag === "Left") {
        return Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("alert alert-danger u-mb0")])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
          Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.delivery.not_possible),
          {address: ""}
        )));
      }
      if (result._1.tag === "Right") {
        if (result._1._1.tag === "WontDeliver") {
          return Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("alert alert-danger u-mb0")])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
            Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.delivery.not_possible),
            {
              address: (() => {
                if (method.tag === "Just") {
                  if (method._1.tag === "DeliveryMethodPickup") { return ""; }
                  if (method._1.tag === "DeliveryMethodShipment") { return Restaumatic$dAddress.defaultFormatBuildingAddress(method._1._1.address); }
                  if (method._1.tag === "DeliveryMethodDineIn") { return ""; }
                  if (method._1.tag === "DeliveryMethodNoContactDelivery") { return Restaumatic$dAddress.defaultFormatBuildingAddress(method._1._1.address); }
                  $runtime.fail();
                }
                if (method.tag === "Nothing") { return ""; }
                $runtime.fail();
              })()
            }
          )));
        }
        if (result._1._1.tag === "ChangeRestaurant") {
          const $0 = result._1._1._1;
          return Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("alert alert-warning")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
            Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.delivery.change_restaurant),
            {}
          )))(() => Specular$dDom$dElement.el("a")([
            Specular$dDom$dElement.class_("btn btn-warning"),
            Specular$dDom$dElement.attr("data-ga-action")("Change restaurant with alternative link"),
            Specular$dDom$dElement.attr("href")($0.path)
          ])(Specular$dDom$dElement.text($0.restaurantName))));
        }
        if (result._1._1.tag === "Ok") { return Specular$dInternal$dRIO.pureImpl(); }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  })(dmethod))(dresult));
};
export {deliveryStatusWidget};
